<div class="auth-content">
  <!-- Login form -->
  <div class="login">
    <div class="logo">
      <img class="image" [src]="theme?.logo">
      <div class="text">
        <div class="title">{{ theme?.product }}</div>
        <div class="subtitle">Workflow Portal</div>
      </div>
    </div>
    <div class="user">
      <div class="form-title">Set your password</div>
      <div class="text">
        <div class="title">Email: </div>
        <div class="subtitle">{{ user?.email }}</div>
      </div>
    </div>
    <div class="login-form">
      <input class="input" [(ngModel)]="name" placeholder="Name" (focus)="error = undefined">
      <input class="input" type="password" [(ngModel)]="password" placeholder="New Password" (keydown.enter)="complete()" (focus)="error = undefined">
      <input class="input" type="password" [(ngModel)]="confirmPassword" placeholder="Confirm New Password" (keydown.enter)="complete()" (focus)="error = undefined">
    </div>
    <div class="button login-button" [class.disabled]="!name?.length || !password?.length || !user?.email" (click)="complete()">Finish the registration</div>
    @if (error) {
      <div class="message error">{{ error }}</div>
    }
  </div>
</div>